import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles(({ palette, spacing }: Theme) => createStyles({
  formControl: {
    minWidth: 120,
  },
  root: {
    marginTop: spacing(2),
    '&:before': {
      borderBottomColor: palette.input.borderBottomColor,
    },
    '&&:hover:before': {
      borderBottomColor: palette.input.borderBottomColor,
    },
    '&:after': {
      borderBottomColor: palette.menuAction.selected,
    },
    '&$focused:after': {
      borderBottomColor: palette.menuAction.selected,
    },
    '&$disabled:before': {
      borderBottomStyle: 'dashed',
    },
  },
  label: {
    '&$focused': {
      color: palette.text.secondary,
    },
  },
  focused: {},
  disabled: {},

  blank: {
    width: '100%',
  },
}), { name: 'FormSelect' });

export default useStyles;
